import { Button, Icon, Text } from '@ui-component-library';

import { useCheckout } from '@components/Checkout/context/CheckoutContext';

export const PackageSummary = () => {
  const { extraData, setExtraData } = useCheckout();

  const selectedPackage = extraData.selectedPackage;
  const selectedForestManagementPlan = extraData.selectedForestManagementPlan;

  return (
    <div className="flex flex-col gap-4">
      {/* Ortofoto — always included in drone orders */}
      <div className="flex flex-row items-start justify-start gap-2">
        <Icon
          name="DroneSimple"
          size="large"
          spacing="medium"
          className="fill-brown-700 bg-stone-200"
        />
        <div className="flex h-full flex-1 flex-col justify-center">
          <div className="flex flex-col gap-1">
            <Text variant="text-sm/leading-normal/medium">Ortofoto</Text>
            <Text variant="text-sm/leading-normal/normal" className="text-cloud-900 mb-3">
              Högupplösta bilder på din skog
            </Text>
          </div>
        </div>
      </div>

      {/* Package selection */}
      {selectedPackage && (
        <div className="flex flex-row items-start justify-start gap-2">
          <Icon
            name="WarningFilled"
            size="large"
            spacing="medium"
            className="fill-brown-700 bg-stone-200"
          />
          <div className="flex h-full flex-1 flex-col justify-center">
            <div className="flex flex-col gap-1">
              <Text variant="text-sm/leading-normal/medium">
                Skadeanalys {selectedPackage.title}
              </Text>
              <Text variant="text-sm/leading-normal/normal" className="text-cloud-900 mb-3">
                {selectedPackage.subtitle}
              </Text>
            </div>
          </div>
          <Button
            variant="secondary"
            size="small"
            onClick={() => setExtraData((prev) => ({ ...prev, selectedPackage: null }))}
          >
            Ta bort
          </Button>
        </div>
      )}

      {/* Forest management plan selection */}
      {selectedForestManagementPlan && (
        <div className="flex flex-row items-start justify-start gap-2">
          <Icon
            name="FolderSimple"
            size="large"
            spacing="medium"
            className="fill-brown-700 bg-stone-200"
          />
          <div className="flex h-full flex-1 flex-col justify-center">
            <div className="flex flex-col gap-1">
              <Text variant="text-sm/leading-normal/medium">Skogsbruksplan</Text>
              <Text variant="text-sm/leading-normal/normal" className="text-cloud-900 mb-3">
                Din skog i siffror - åtgärder, volym mm.
              </Text>
            </div>
          </div>
          <Button
            variant="secondary"
            size="small"
            onClick={() =>
              setExtraData((prev) => ({ ...prev, selectedForestManagementPlan: null }))
            }
          >
            Ta bort
          </Button>
        </div>
      )}
    </div>
  );
};
